import {WmWoundAnswer} from '../../interfaces/wound-management/wm-wound-answer';
import {LightUser} from '../../interfaces/core/light-user';
import {WmWoundAnswerOption} from '../../interfaces/wound-management/wm-wound-answer-option';
import {WmWoundQuestion} from '../../interfaces/wound-management/wm-wound-question';
import {WmWoundDocumentationEntry} from '../../interfaces/wound-management/wm-wound-documentation-entry';
import {UserService} from '../../services/core/user.service';
import {LightUserFactory} from '../core/light-user-factory';
import {cloneDeep} from 'lodash-es';

export class WmWoundAnswerFactory {

  /**
   *
   * @param wmWoundAnswer
   */
  public static fromObject(wmWoundAnswer: any): WmWoundAnswer {
    return new class implements WmWoundAnswer {
      comment: string = wmWoundAnswer.comment;
      user: LightUser = wmWoundAnswer.user;
      userId: number = wmWoundAnswer.user_id;
      wmWoundAnswerOptionId: number = wmWoundAnswer.wm_wound_answer_option_id;
      wmWoundDocumentationEntryUuid: string = wmWoundAnswer.wm_wound_documentation_entry_uuid;
      wmWoundQuestionId: number = wmWoundAnswer.wm_wound_question_id;
      answer: string = wmWoundAnswer.answer;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = wmWoundAnswer.id;
      uuid: string = wmWoundAnswer.uuid;
      modified: string = wmWoundAnswer.modified;
      created: string = wmWoundAnswer.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param wmWoundAnswerOption
   * @param wmWoundDocumentationEntry
   */
  public static fromWmWoundAnswerOption(wmWoundAnswerOption: WmWoundAnswerOption,
                                        wmWoundDocumentationEntry: WmWoundDocumentationEntry): WmWoundAnswer {
    return new class implements WmWoundAnswer {
      comment: string = null;
      user: LightUser = UserService.getUser();
      userId: number = UserService.getUser().id;
      wmWoundAnswerOptionId: number = wmWoundAnswerOption.id;
      wmWoundDocumentationEntryUuid: string = wmWoundDocumentationEntry.uuid;
      wmWoundQuestionId: number = wmWoundAnswerOption.wmWoundQuestionId;
      answer: string = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param wmWoundQuestion
   * @param wmWoundDocumentationEntry
   */
  public static fromWmWoundQuestion(wmWoundQuestion: WmWoundQuestion,
                                    wmWoundDocumentationEntry: WmWoundDocumentationEntry): WmWoundAnswer {
    return new class implements WmWoundAnswer {
      comment: string = null;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());
      userId: number = UserService.getUser().id;
      wmWoundAnswerOptionId: number = null;
      wmWoundDocumentationEntryUuid: string = wmWoundDocumentationEntry.uuid;
      wmWoundQuestionId: number = wmWoundQuestion.id;
      answer: string = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param wmWoundAnswers
   */
  public static fromArray(wmWoundAnswers: any[]): WmWoundAnswer[] {
    return wmWoundAnswers.map(wmWoundAnswer => {
      return WmWoundAnswerFactory.fromObject(wmWoundAnswer);
    });
  }

  /**
   *
   * @param wmWoundAnswer
   */
  public static toRemote(wmWoundAnswer: WmWoundAnswer): any {
    return  {
      comment: wmWoundAnswer.comment,
      wm_wound_answer_option_id: wmWoundAnswer.wmWoundAnswerOptionId,
      wm_wound_documentation_entry_uuid: wmWoundAnswer.wmWoundDocumentationEntryUuid,
      wm_wound_question_id: wmWoundAnswer.wmWoundQuestionId,
      answer: wmWoundAnswer.answer,
      uuid: wmWoundAnswer.uuid,
      modified: wmWoundAnswer.modified,
      created: wmWoundAnswer.created
    };
  }

  /**
   *
   * @param wmWoundAnswers
   */
  public static toArray(wmWoundAnswers: WmWoundAnswer[]): any[] {
    return wmWoundAnswers.map(_wmWoundAnswer => WmWoundAnswerFactory.toRemote(_wmWoundAnswer));
  }

  /**
   *
   * @param wmWoundAnswer
   * @param wmWoundDocumentationEntryUuid
   */
  public static copyWmWoundAnswer(
    wmWoundAnswer: WmWoundAnswer,
    wmWoundDocumentationEntryUuid: string = null
  ): WmWoundAnswer {
    const _wmWoundAnswer = cloneDeep(wmWoundAnswer);
    _wmWoundAnswer.wmWoundDocumentationEntryUuid = wmWoundDocumentationEntryUuid;
    _wmWoundAnswer.created = null;
    _wmWoundAnswer.modified = null;
    _wmWoundAnswer.user = UserService.getUser();
    _wmWoundAnswer.userId = UserService.getUser().id;
    _wmWoundAnswer.uuid = null;
    _wmWoundAnswer.id = null;

    return _wmWoundAnswer;
  }

}
